<section style="height: 100%">
  <div class="login-box">
    <div class="login-logo">
      <img src="assets/images/CAPA3e.png" alt="capa logo">
    </div>
    <!-- /.login-logo -->
    <div class="login-box-body">
      <h3 class="login-box-msg" i18n="@@accountCreation">Account creation</h3>
      <form [formGroup]="LicenseNumberForm" (ngSubmit)="onSubmitLicenseNumber()" style="border: 1px solid; padding: 10px">
        <button class="btn btn-xs btn-primary tooltip" style="opacity: 1; float: right;">
          <span class="fa fa-question"></span>
          <div class="top">
            <p i18n="@@licenseNumberExplanation">You can find your license number in the "Options" window of CAPA on your tablet. It consists of 6 series of 4 characters.</p>
            <em></em>
          </div>
        </button>
        <h4 class="login-box-msg" i18n="@@enterLicenseNumber">Enter your license number</h4>
        <div class="form-group has-feedback">
          <label for="licenseNumber" i18n="@@licenseNumber">License number</label>
          <input id="licenseNumber" [disabled]="isLicenseNumberValid" type="text" formControlName="licenseNumber" class="form-control" placeholder="ex : AAAA-BBBB-CCCC-DDDD-EEEE-FFFF">
          <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <button type="submit" class="btn btn-primary btn-block btn-flat" [disabled]="isLicenseNumberValid || !LicenseNumberForm.valid" i18n="@@verify">VERIFY</button>
          </div>
        </div>
      </form>
      <br />
      <form *ngIf="isLicenseNumberValid" [formGroup]="DetailsForm" (ngSubmit)="onSubmitDetails()" style="border: 1px solid; padding: 10px">
        <h4 class="login-box-msg" i18n="@@enterCoordinates">Enter your details</h4>
        <div class="form-group has-feedback">
          <label for="firstname" i18n="@@firstname">Firstname *</label>
          <input id="firstname" type="text" formControlName="firstname" class="form-control" i18n-placeholder placeholder="Firstname">
        </div>

        <div class="form-group has-feedback">
          <label for="lastname" i18n="lastname">Lastname *</label>
          <input id="lastname" type="text" formControlName="lastname" class="form-control" i18n-placeholder placeholder="Lastname">
        </div>

        <div class="form-group has-feedback">
          <div class="formfield-select">

            <label for="language" i18n="@@langage">Langage *</label>

            <div class="formfield-select--container">

              <select id="language" formControlName="language">
                <option i18n="@@french">French</option>
                <option i18n="@@english">English</option>
                <option i18n="@@german">German</option>
              </select>

            </div>

          </div>
        </div>

        <div class="form-group has-feedback">
          <label for="email" i18n="@@email">Email *</label>
          <input id="email" type="email" formControlName="email" class="form-control" i18n-placeholder placeholder="exemple@cotral.com">
        </div>

        <div class="form-group has-feedback">
          <label for="password" i18n="@@password">Password *</label>
          <input id="password" type="password" formControlName="password" class="form-control" i18n-placeholder placeholder="Minimum 8 characters and 1 digit">
        </div>

        <div class="form-group has-feedback">
          <label for="phone" i18n="@@phone">Phone</label>
          <input id="phone" type="text" formControlName="phone" class="form-control" i18n-placeholder placeholder="Phone">
        </div>

        <div class="row">
          <div class="col-xs-12">
            <button type="submit" class="btn btn-primary btn-block btn-flat" [disabled]="!DetailsForm.valid" i18n="@@validate">VALIDATE</button>
          </div>
        </div>
      </form>

    </div>
  </div>
</section>


<div *ngIf="errorAccountCreation" class="alert alert-danger alert-dismissible" style="border-radius: unset; position: fixed; top:50px; width: 100%;"><span i18n="@@errorAccountCreation">An account already exists for the address </span> {{ DetailsForm.value.email }}</div>
<div *ngIf="errorLicenseNumber" class="alert alert-danger alert-dismissible" style="border-radius: unset; position: fixed; top:50px; width: 100%;"><span i18n="@@errorLicenseNumber">License number unknown or already used.</span></div>
<div *ngIf="errorPassword" class="alert alert-success alert-dismissible" style="border-radius: unset; position: fixed; top:50px; width: 100%;"><span i18n="@@passwordRegex">The password must contain at least 8 characters and one number.</span></div>
<div *ngIf="successAccountCreation" class="alert alert-success alert-dismissible" style="border-radius: unset; position: fixed; top:50px; width: 100%;"><span i18n="@@successAccountCreation">Successful account creation. You can now access the list of your results.</span></div>
